import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown, Check } from 'lucide-react';
import './StatusDropdown.css';

const STATUS_OPTIONS = [
  { value: 'pendiente', label: 'PENDIENTE', color: '#ffa500' },
  { value: 'confirmado', label: 'CONFIRMADO', color: '#00ff7f' },
  { value: 'cancelado', label: 'CANCELADO', color: '#ff4b2b' },
  { value: 'ausente', label: 'AUSENTE', color: '#ff4b2b' },
  { value: 'completado', label: 'COMPLETADO', color: '#00e5ff' },
  { value: 'atendido', label: 'ATENDIDO', color: '#00e5ff' },
  { value: 'presente', label: 'PRESENTE', color: '#00ff7f' },
  { value: 'en-llamado', label: 'EN LLAMADO', color: '#ffca28' },
];

const StatusDropdown = ({ value, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const currentOption = STATUS_OPTIONS.find(opt => opt.value === value?.toLowerCase()) || STATUS_OPTIONS[0];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className={`custom-status-dropdown ${isOpen ? 'is-open' : ''}`} ref={dropdownRef} style={{ zIndex: isOpen ? 9999 : 1 }}>
      <button 
        className={`status-trigger ${currentOption.value}`}
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen(!isOpen);
        }}
        style={{ borderColor: `${currentOption.color}44`, color: currentOption.color, backgroundColor: `${currentOption.color}11` }}
      >
        <span>{currentOption.label}</span>
        <ChevronDown size={14} className={`arrow ${isOpen ? 'open' : ''}`} />
      </button>

      {isOpen && (
        <div className="status-options-menu animate-fade-in">
          {STATUS_OPTIONS.map((option) => (
            <div 
              key={option.value}
              className={`status-option-item ${option.value === value ? 'active' : ''}`}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onChange(option.value);
                setTimeout(() => setIsOpen(false), 10);
              }}
            >
              <div className="option-dot" style={{ backgroundColor: option.color }}></div>
              <span style={{ color: option.value === value ? option.color : 'inherit' }}>{option.label}</span>
              {option.value === value && <Check size={14} className="check-icon" style={{ color: option.color }} />}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default StatusDropdown;
